import { useNavigate } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { AgreementPlan } from "@modules/agreementPlans/types";
import { AgreementPlanFormValues } from "@modules/agreementPlans/validations";

import { createAgreementPlanService } from "./service";
import { UseCreateAgreementPlanMutationOptions } from "./types";

export function useCreateAgreementPlanMutation(
  options?: UseCreateAgreementPlanMutationOptions
) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { open } = useNotification();

  return useMutation<AgreementPlan, ApiError, AgreementPlanFormValues>({
    mutationFn: createAgreementPlanService,
    onSuccess: (agreementplan: AgreementPlan) => {
      open?.({
        type: "success",
        message: translate("v1/agreement_admin.success.create"),
      });

      navigate(`/agreement_agreementplans/edit/${agreementplan.id}`);
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
